<ion-header class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ng-container>
            <ion-title>{{ 'APPOINTMENT_ADD_MEMBERS' | translate }}</ion-title>
            <ion-buttons slot="end">
                <ion-button (click)="backClicked()">
                    <ion-icon slot="icon-only"
                              color="dark"
                              name="close"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ng-container>
    </ion-toolbar>
</ion-header>

<div class="scroll-box ion-padding">

    <form *ngIf="!loading && user"
          #f="ngForm"
          novalidate
          class="{{class}}"
          (ngSubmit)="inviteParticipants()">

        <ion-grid class="ion-no-padding">

            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <ion-item id="invitation-box"
                              class="invitations"
                              [ngClass]="{ 'has-error': validate && validationErrors.participants }">
                        <ng-template #emptyTemplate
                                     let-attrs="attrs"
                                     class="ion-text-center">
                            {{ 'APPOINTMENT_MEMBERS_NO_ITEMS' | translate }}
                        </ng-template>
                        <ng-template #participantTemplate
                                     let-attrs="attrs">
                            {{attrs.data.firstname}} {{attrs.data.lastname}}
                        </ng-template>
                        <ion-auto-complete *ngIf="participants.length <= 14"
                                           #autocomplete
                                           [maxResults]="6"
                                           [dataProvider]="participantService"
                                           [dataProviderAttribute]="'participants'"
                                           [exclude]="participants.concat(appointment.participants)"
                                           [template]="participantTemplate"
                                           [selectionTemplate]="participantTemplate"
                                           [emptyTemplate]="emptyTemplate"
                                           [options]="{mode: 'ios', placeholder: 'APPOINTMENT_ATTENDEE_LIST_SEARCH_PLACEHOLDER' | translate }"
                                           (ionAutoInput)="autocompleteFocus()"
                                           (itemsShown)="autocompleteFocus()"
                                           (itemsHidden)="autocompleteBlur()"
                                           (autoBlur)="autocompleteBlur()"
                                           (itemSelected)="addParticipant($event)">
                        </ion-auto-complete>
                    </ion-item>
                </ion-col>
            </ion-row>

            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <ng-container *ngFor="let participant of participants">
                        <div class="invited-participant">
                            {{participant.firstname}} {{participant.lastname}}
                            <svg-icon (click)="removeParticipant(participant)"
                                      [applyClass]="true"
                                      src="/assets/icons/ico-close.svg"
                                      class="icon fill-dark">
                            </svg-icon>
                        </div>
                    </ng-container>
                </ion-col>
            </ion-row>
        </ion-grid>
    </form>
</div>

<ion-footer>
    <ion-row class="ion-no-padding"
             [ngClass]="{'action-buttons': plt.sizeSm}">
        <ng-container *ngIf="plt.sizeSm">
            <ion-col size="6"
                     class="ion-no-padding">
                <ion-button class="btn-close"
                            (click)="backClicked()">
                    {{ 'BUTTON_CANCEL' | translate }}
                </ion-button>
            </ion-col>
            <ion-col size="6"
                     class="ion-no-padding">
                <ion-button (click)="inviteParticipants()">
                    {{ 'APPOINTMENT_INVITE_MEMBERS' | translate }}
                </ion-button>
            </ion-col>
        </ng-container>
        <ion-col *ngIf="!plt.sizeSm"
                 class="ion-no-padding ion-text-right">
            <ion-button (click)="inviteParticipants()">
                {{ 'APPOINTMENT_INVITE_MEMBERS' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>

<ng-container *ngIf="loading">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>